<div class="logout-page">

  <!-- LINKER CONTENT-BEREICH -->
  <section class="logout-panel">

    <!-- HEADER -->
    <header class="logout-header">
      <div class="header-left">
        <img src="/images/branding/sps_logo_logout.svg" alt="Logo" class="logo">
      </div>
      <div class="header-right">
        <span>Eine Marke der DSV Gruppe</span>
      </div>
    </header>

    <!-- MAIN CONTENT -->
    <main class="logout-main">
      <div class="text-3xl mb-3" [innerHTML]="i18n?.i18nLng()['LOGOUTPAGETITLE'] | safeHtml"></div>
      <a href="/" class="sps-link logout" target="_self" [innerHTML]="i18n?.i18nLng()['LOGOUTRELOGIN'] | safeHtml"></a>
      <div class="contact-card gray mt-5">
        <div class="contact-text title line-height-3">
          Ihr Feedback zählt!
        </div>
        <div class="contact-text info line-height-3 mb-2">
          Bitte nehmen Sie sich 2 Minuten Zeit und geben Sie uns Ihr Feedback. Ihre Meinung ist uns wichtig und gibt uns wertvolle Einblicke, um unser Angebot kontinuierlich zu verbessern.<br>Vielen Dank für Ihre Unterstützung.
        </div>
        <p-button label="Jetzt teilnehmen" [disabled]="true"/>
      </div>

    </main>


    <footer aria-label="Footer" class="logout-footer" role="contentinfo">
      <div class="footer-content">
        <nav aria-label="Footer Navigation" class="links">
          <a tabindex="0"
             [href]="spsContactUrl"
             target="_blank"
             [attr.aria-label]="i18n?.i18nLng()['CONTACTPAGE']">{{ i18n?.i18nLng()['CONTACT'] }}
          </a>
          <span class="separator">·</span>
          <a tabindex="0"
             [href]="spsImprintUrl"
             target="_blank"
             [attr.aria-label]="i18n?.i18nLng()['IMPRINTPAGE']">{{ i18n?.i18nLng()['IMPRINT'] }}
          </a>
          <span class="separator">·</span>
          <a tabindex="0"
             [href]="spsAGBUrl"
             target="_blank"
             [attr.aria-label]="i18n?.i18nLng()['T&CPAGE']"><abbr
              [title]="i18n?.i18nLng()['T&CPAGE']">{{ i18n?.i18nLng()['T&C'] }}</abbr>
          </a>
          <span class="separator">·</span>
          <a tabindex="0"
             [href]="spsPrivacyUrl"
             target="_blank"
             [attr.aria-label]="i18n?.i18nLng()['PRIVACYPAGE']">{{ i18n?.i18nLng()['PRIVACY'] }}
          </a>
        </nav>
        <div>
          {{ i18n?.i18nLng()['COPYRIGHT'] }}
        </div>
      </div>
    </footer>
  </section>

  <aside class="logout-image" [style.background-image]="'url(/images/content/logout_giro_checkout.svg)'">
    <div class="image-overlay">
      <div class="flex text-top line-height-2 text-xl">
        Bleiben Sie informiert
      </div>
      <div class="flex text-top text-4xl line-height-2">
        Aktuelles & Produkte der S‑Public Services
      </div>
      <div class="flex text-top subline text-4xl line-height-2 mb-3">
        Entdecken Sie unser gesamtes Produktportfolio und aktuelle Themen auf unserer Website.
      </div>
      <p-button  variant="outlined" label="Mehr erfahren" severity="info" (click)="redirectToPublicServices()"></p-button>
    </div>
  </aside>

</div>
